import { render } from "./AdminSubcategories.vue?vue&type=template&id=a7f62a92&scoped=true"
import script from "./AdminSubcategories.vue?vue&type=script&lang=js"
export * from "./AdminSubcategories.vue?vue&type=script&lang=js"

import "./AdminSubcategories.vue?vue&type=style&index=0&id=a7f62a92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7f62a92"]])

export default __exports__